// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo_2scOn{width:calc(100% - var(--gutter)*3)}.logo_2scOn.isFullWidth_3z-Aa{width:100%}.logoImage_3aC1i{display:block;margin:0 auto}@media only screen and (max-width:599px){.logoImage_3aC1i{height:24px;margin-bottom:4px}}.icon_2SmkE{font-size:1.33rem;color:#49bcbd}.companyName_2W1y9{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;gap:0}@media only screen and (min-width:600px){.companyName_2W1y9{gap:24px}}.companyText_qlIVe{font-size:.78rem;font-weight:700;color:#374949}@media only screen and (min-width:600px){.companyText_qlIVe{font-size:1.11rem;margin-top:4px}}.subtitle_2r2zm{color:var(--black-058,rgba(0,0,0,.58));text-align:center;-webkit-font-feature-settings:\"halt\" on;font-feature-settings:\"halt\" on;font-family:Hiragino Sans,sans-serif;font-size:13px;font-style:normal;font-weight:300;line-height:150%;letter-spacing:.4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": "logo_2scOn",
	"isFullWidth": "isFullWidth_3z-Aa",
	"logoImage": "logoImage_3aC1i",
	"icon": "icon_2SmkE",
	"companyName": "companyName_2W1y9",
	"companyText": "companyText_qlIVe",
	"subtitle": "subtitle_2r2zm"
};
module.exports = ___CSS_LOADER_EXPORT___;
